﻿import { type ReactNode, useCallback, useEffect, useState } from 'react';
import { getSession } from '../services/api';
import type { UserSession } from '../context/auth-context.types.ts';
import { AuthContext } from '../context/auth-context.ts';

export function AuthProvider({ children }: { children: ReactNode }) {
  const [userSession, setUserSession] = useState<UserSession | undefined>(undefined);
  const [isLoading, setIsLoading] = useState(true);

  const checkSession = useCallback(async () => {
    try {
      const session = await getSession();
      sessionStorage.removeItem('redirected');
      setUserSession(session);
    } catch (error) {
      console.error('Authentication check failed:', error);
      setUserSession(undefined);
    }
  }, []);

  useEffect(() => {
    (async () => {
      await checkSession();
      setIsLoading(false);
    })();

    const sessionHandler = setInterval(() => checkSession(), 300_000);

    return () => {
      clearInterval(sessionHandler);
    };
  }, [checkSession]);

  return (
    <AuthContext.Provider
      value={{
        isAuthenticated: !!userSession?.userId,
        isLoading,
        userSession,
        checkSession,
      }}
    >
      {children}
    </AuthContext.Provider>
  );
}
